import React, { useEffect, useState, useMemo } from "react";

import GanttTimelineCanvas from "./canttChart";
import { useHeader } from "components/header/store";
import { monitorCenterAPI, getTaskData } from "api";

const FormatYMD = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
};
const TodayYMD = () => FormatYMD(new Date());

const WorkingPage = () => {
  const { setTitle, setButtons } = useHeader();
  useEffect(() => {
    setTitle("Working");
    setButtons(null);
  }, [setTitle, setButtons]);

  const [blocks, setBlocks] = useState(null);

  const [startDate, setStartDate] = useState<string>("2025-09-23");
  const [endDate, setEndDate] = useState<string>("2025-09-23");

  const pathname =
    typeof window !== "undefined" ? window.location.pathname : "";
  const mode = useMemo<"connected" | "working">(() => {
    if (pathname === "/working") return "connected";
    if (pathname === "/workingTest") return "working";
    return "connected";
  }, [pathname]);

  const fetchData = async (s, e) => {
    const api =
      mode === "connected"
        ? monitorCenterAPI.connectedTime
        : monitorCenterAPI.workingTime;

    try {
      const res = await getTaskData(() => api(s, e));
      const raw = res?.result;

      if (!raw || !Array.isArray(raw)) {
        setBlocks([]);
        return;
      }

      const norm = raw.map((b) => ({
        user: b.user,
        seconds: b.seconds,
        step: b.step,
        data: b.data.map((d) => ({
          instance: d.instance,
          seconds: d.seconds,
          values: d.values.map((v) => {
            let ts = v?.[0];
            if (ts > 1e12) ts = Math.round(ts / 1000);
            const sVal = v?.[1] == null ? "0" : String(v[1]);
            return [ts, sVal];
          }),
        })),
      }));
      setBlocks(norm);
    } catch (error) {
      console.error("fetchData error:", error);
      setBlocks([]);
    }
  };

  useEffect(() => {
    if (!blocks) {
      applyToday();
    }
  });

  const handleApplyDateRange = (startISO, endISO) => {
    setStartDate(startISO);
    setEndDate(endISO);
    fetchData(startISO, endISO);
  };

  const applyToday = () => {
    const d = TodayYMD();
    setStartDate(d);
    setEndDate(d);
    fetchData(d, d);
  };

  if (!blocks) return <div style={{ padding: 16 }}>데이터 없음</div>;

  return (
    <div style={{ padding: 16, display: "grid", gap: 10 }}>
      <GanttTimelineCanvas
        blocks={blocks}
        labelWidth={260}
        rowHeight={24}
        onApplyDateRange={handleApplyDateRange}
        initialDateRange={{ startISO: startDate, endISO: endDate }}
      />
    </div>
  );
};

export default WorkingPage;
